import styled from "styled-components";

export const ContainerMainTutores = styled.main`
  min-height: 100vh;
  padding-bottom: 120px;


  display: flex;
  flex-direction: column;
  align-items: center;

  padding-top: 120px;

  gap: 32px;

  background-color: #d9d9dd;




  .cards{
    display: flex;
    flex-direction: column;
    gap: 32px;


  @media (min-width: 800px) {
    flex-direction: row;
    
  }
  }
  `
